// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file ga/config_manager/user/user.proto (package ga.config_manager.user, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { CasinoKeyInfo } from "../casinokey/casinokey_pb";
import { file_ga_config_manager_casinokey_casinokey } from "../casinokey/casinokey_pb";
import type { MeRequestSchema, MeResponseSchema } from "./user_admin_pb";
import { file_ga_config_manager_user_user_admin } from "./user_admin_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ga/config_manager/user/user.proto.
 */
export const file_ga_config_manager_user_user: GenFile = /*@__PURE__*/
  fileDesc("CiFnYS9jb25maWdfbWFuYWdlci91c2VyL3VzZXIucHJvdG8SFmdhLmNvbmZpZ19tYW5hZ2VyLnVzZXIiFwoVTWV0YWRhdGFTdHJlYW1SZXF1ZXN0Ik8KCE1ldGFkYXRhEkMKD2Nhc2lub19rZXlfaW5mbxgBIAEoCzIqLmdhLmNvbmZpZ19tYW5hZ2VyLmNhc2lub2tleS5DYXNpbm9LZXlJbmZvMsIBCgxVc2Vyc1NlcnZpY2USSwoCTWUSIS5nYS5jb25maWdfbWFuYWdlci51c2VyLk1lUmVxdWVzdBoiLmdhLmNvbmZpZ19tYW5hZ2VyLnVzZXIuTWVSZXNwb25zZRJlCg5NZXRhZGF0YVN0cmVhbRItLmdhLmNvbmZpZ19tYW5hZ2VyLnVzZXIuTWV0YWRhdGFTdHJlYW1SZXF1ZXN0GiAuZ2EuY29uZmlnX21hbmFnZXIudXNlci5NZXRhZGF0YSIAMAFC5AEKGmNvbS5nYS5jb25maWdfbWFuYWdlci51c2VyQglVc2VyUHJvdG9QAVpFeGRldnRlYW0uY29tL2E4ci9jb25maWctbWFuYWdlci9pbnRlcm5hbC9wcm90by9nYS9jb25maWdfbWFuYWdlci91c2VyogIDR0NVqgIVR2EuQ29uZmlnTWFuYWdlci5Vc2VyygIVR2FcQ29uZmlnTWFuYWdlclxVc2Vy4gIhR2FcQ29uZmlnTWFuYWdlclxVc2VyXEdQQk1ldGFkYXRh6gIXR2E6OkNvbmZpZ01hbmFnZXI6OlVzZXJiBnByb3RvMw", [file_ga_config_manager_casinokey_casinokey, file_ga_config_manager_user_user_admin]);

/**
 * @generated from message ga.config_manager.user.MetadataStreamRequest
 */
export type MetadataStreamRequest = Message<"ga.config_manager.user.MetadataStreamRequest"> & {
};

/**
 * Describes the message ga.config_manager.user.MetadataStreamRequest.
 * Use `create(MetadataStreamRequestSchema)` to create a new message.
 */
export const MetadataStreamRequestSchema: GenMessage<MetadataStreamRequest> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_user_user, 0);

/**
 * @generated from message ga.config_manager.user.Metadata
 */
export type Metadata = Message<"ga.config_manager.user.Metadata"> & {
  /**
   * @generated from field: ga.config_manager.casinokey.CasinoKeyInfo casino_key_info = 1;
   */
  casinoKeyInfo?: CasinoKeyInfo;
};

/**
 * Describes the message ga.config_manager.user.Metadata.
 * Use `create(MetadataSchema)` to create a new message.
 */
export const MetadataSchema: GenMessage<Metadata> = /*@__PURE__*/
  messageDesc(file_ga_config_manager_user_user, 1);

/**
 * @generated from service ga.config_manager.user.UsersService
 */
export const UsersService: GenService<{
  /**
   * @generated from rpc ga.config_manager.user.UsersService.Me
   */
  me: {
    methodKind: "unary";
    input: typeof MeRequestSchema;
    output: typeof MeResponseSchema;
  },
  /**
   * @generated from rpc ga.config_manager.user.UsersService.MetadataStream
   */
  metadataStream: {
    methodKind: "server_streaming";
    input: typeof MetadataStreamRequestSchema;
    output: typeof MetadataSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_ga_config_manager_user_user, 0);

